<template>
  <div 
    v-bind="$attrs" 
    class="p-6 relative backdrop-blur-[6px]"
    :class="isBusiness ? 'border border-[#A3A3DB]/20' : 'bg-[rgba(21,33,85,0.8)] border-2 border-primary-brand-100'"
  >
    <slot/>
  </div>
</template>

<script setup>
  import { computed } from 'vue'
  import { useStore } from 'vuex'
  import { useRoute } from 'vue-router'

  const store = useStore()
  const route = useRoute()

  const isBusiness = computed(() => {
    return (route.query.target || store.getters.getTarget) === 'business'
  })
</script>